export const identifiers = {
  control: 'control-container',
  option: 'selected-option',
}
